export const ErrorCode = {
    DEPLOYED_COUNT_INSUFFICIENT: '投放車輛數不足',
    OWNER_ID_IS_BOUND: '停車場業者已被其他站點綁定，無法刪除',
    INSURANCE_IS_BOUND: '行車守護已被其他車款綁定，無法刪除',
    DEVICE_DATA_MISSING: '車機資料尚未建立',
    ACC_ON_CAN_NOT_TURN_OFF: '車機啟動中無法斷電',
    WRONG_DEVICE_MODEL: '無法對應故障碼類型',
    CAR_NOT_FOUND: '車輛不存在',
    CAR_AWAIT_SETTING: '車輛等待設定中',
    CAR_NOT_BIND_STATION: '車輛尚未綁定站點',
    STATION_NOT_FOUND: '站點不存在',
    ORDER_NOT_FINISH_YET: '訂單還未完成，無法新增其他費用',
    ORDER_ALREADY_DROP_OFF: '該訂單已還車',
    REFUND_PROCESSING: '仍有其他退款處理中',
    COUPON_CODE_DUPLICATE: '優惠碼代碼不可重複',
    ORDER_TIME_OVERLAP: '訂單時間重疊',
    CAR_CANNOT_USE: '車輛不可使用',
    CAR_STATUS_WRONG: '車輛狀態錯誤',
    VEHICLE_NOT_AVAILABLE: '車輛此時段不可使用',
    DUPLICATE_ACCOUNT: '帳號不可重複',
    /* traffic ticket */
    DATA_CAN_NOT_EMPTY: '資料不可為空',
    TICKET_NUMBER_CAN_NOT_EMPTY: '罰單編號不可為空',
    TICKET_NUMBER_CAN_NOT_REPEAT: '罰單編號不可重複',
    ORDER_DATA_NOT_EXISTS: '訂單資料不存在',
    ORDER_CAR_DATA_NOT_EXISTS: '訂單車輛資料不存在',
    DATA_NOT_EXISTS: '資料不存在',
    DATA_STATUS_CAN_NOT_UPDATE: '此筆資料狀態已不可異動',
    NO_ATTACHMENT_CAN_NOT_TRANSFER: '查無附件不可進行轉罰',
    NO_ORDER_CAN_NOT_TRANSFER: '查無訂單不可進行轉罰',
    PARKING_FEE_CAN_NOT_TRANSFER: '停車費不可進行轉罰',
    NO_ORDER_CAN_NOT_COLLECT_REMIT: '查無訂單不可進行代繳',
    NO_ORDER_CAN_NOT_SELF_PAY: '查無訂單不可進行自繳',
    PLATE_NUMBER_CAN_NOT_CHANGE: '車牌不可變更',
    PLATE_NUMBER_NOT_IN_ORDER: '車牌與訂單不相符'
};

export const MapOptions = {
    center: { lat: 25.046200, lng: 121.517552 },
    zoom: 12,
    minZoom: 6,
    clickableIcons: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false
};

export const ChineseDay = {
    Sunday: '日',
    Monday: '一',
    Tuesday: '二',
    Wednesday: '三',
    Thursday: '四',
    Friday: '五',
    Saturday: '六'
};

export const RatingRuleName = {
    INIT: '起始值',
    RESTRICT_DISCOUNT: '定價計算',
    SUSPENSION: '停權'
};
export const RatingItemCategory = {
    CAR_RESERVATION: '關於預約',
    CAR_USAGE: '關於使用',
    CAR_RETURN: '關於還車'
};
export const RatingItemSubCategory = {
    OTHER: '其他',
    RENTAL: '單次租用',
    ACTIVE_CANCEL: '主動取消 (同站租還)',
    PASSIVE_CANCEL: '被動取消 (同站租還)',
    SPEEDING: '超速',
    ACCESSORIES_NOT_IN_PLACE: '配件未歸位',
    NOT_CLEAN: '車輛不潔',
    DAMAGE: '車輛損壞',
    EARLY_RETURN: '提前還車 (同站租還)',
    OVERTIME_RETURN: '逾時還車',
    ILLEGAL_PARKING: '違規停車'
};
export const RatingItemDescription = {
    OTHER: '自行填寫',
    SINGLE_RENTAL_ITEM_ONE: '單次租用',
    ACTIVE_CANCEL_ITEM_ONE:
        '預計取車前三小時取消 (預約 < 10小時) *以下兩種情況不會扣分\n1. 3 小時內之臨時預約 (預約時間與預計取車時間相差 3 小時內)\n2. 取車時間到，但前一位用戶尚未還車',
    ACTIVE_CANCEL_ITEM_TWO:
        '預計取車前三小時取消 (預約 ≥ 10小時) *以下兩種情況不會扣分\n1. 3 小時內之臨時預約 (預約時間與預計取車時間相差 3 小時內)\n2. 取車時間到，但前一位用戶尚未還車',
    PASSIVE_CANCEL_ITEM_ONE: '未主動取消預約 (預約 < 10 小時)',
    PASSIVE_CANCEL_ITEM_TWO: '未主動取消預約 (預約 ≥ 10 小時)',
    SPEEDING_ITEM_ONE: '超速 20 km 以下',
    SPEEDING_ITEM_TWO: '超速 20 km - 未滿 40 km',
    SPEEDING_ITEM_THREE: '超速 40 km 以上',
    ACCESSORIES_NOT_IN_PLACE_ITEM_ONE: '配件未歸位',
    NOT_CLEAN_ITEM_ONE: '遺留寵物毛髮',
    NOT_CLEAN_ITEM_TWO: '造成車輛髒污',
    NOT_CLEAN_ITEM_THREE: '異/菸味殘留',
    DAMAGE_ITEM_ONE: '未主動通報車損',
    DAMAGE_ITEM_TWO: '輕微車損',
    DAMAGE_ITEM_THREE: '嚴重車損',
    EARLY_RETURN_ITEM_ONE: '提前 24 小時以上還車 (每 24 小時扣分)',
    OVERTIME_RETURN_ITEM_ONE: '逾時還車',
    OVERTIME_RETURN_ITEM_TWO: '逾時還車 (影響後續用戶)',
    ILLEGAL_PARKING_ITEM_ONE: '未停放於規範區域內',
    ILLEGAL_PARKING_ITEM_TWO: '停放於特殊車格',
    ILLEGAL_PARKING_ITEM_THREE: '其他違規停車',
    ILLEGAL_PARKING_ITEM_FOUR: '停放於累進費率停車格'
};

export const PlanDateType = {
    NORMAL_DAY: '平日',
    HOLIDAY: '假日',
    NON_DISCOUNT_DAY: '不折扣日'
};
export const PlanDiscountType = {
    UNIT_RENT_DISCOUNT_DOLLAR: ['每計價區間租金折扣', '元'],
    TOTAL_RENT_DISCOUNT_PERCENTAGE: ['訂單租金金額', '折'],
    TOTAL_RENT_DISCOUNT_DOLLAR: ['訂單租金折抵', '元'],
    TOTAL_RENT_DISCOUNT_MINUTE: ['訂單折扣', '分鐘租金'],
    TOTAL_MILE_DISCOUNT_KILOMETER: ['訂單行駛里程折抵', '公里'],
    MILE_FEE_DISCOUNT_PERCENTAGE: ['訂單行駛里程費', '折'],
    TOTAL_MILE_FEE_DISCOUNT_DOLLAR: ['訂單行駛里程費折扣', '元']
};
export const PlanRestrictionType = {
    AMOUNT_RESTRICTION: ['總金額滿', '元'],
    TIME_RESTRICTION: ['租借時間滿', '分鐘'],
    MILE_RESTRICTION: ['行駛里程滿', '公里']
};
export const CouponConditionType = {
    TIME_PRICE: ['總金額滿', '元', 'TIME_PRICE'],
    TIME: ['租借時間滿', '分鐘', 'TIME_MIN'],
    MILEAGE: ['行駛里程滿', '公里', 'MILEAGE_KM'],
    TAG: ['貼上標籤時：', '', 'TAG']
};
export const CouponIssueConditionType = {
    BIRTHDAY: ['', '月生日之會員'],
    TIMES_BELOW_IN_SPECIFIC_DAYS: ['天內租車次數', '次以下'],
    NOT_RENTED_IN_SPECIFIC_DAYS: ['', '天內未租車之審核通過會員'],
    MAILING_ADDRESS: ['通訊地', ''],
    IN_MEMBER_LIST: ['發放名單', '']
};
export const InviteCodeDiscountType = {
    TOTAL_RENT_DISCOUNT_DOLLAR: ['訂單租金折抵', '元'],
    TOTAL_RENT_DISCOUNT_MINUTE: ['訂單折扣', '分鐘租金']
};
export const ImportMemberColumns = [
    { dataIndex: 'id', title: '會員編號' }
];

export const bussinessStatusConfig = {
    AVAILABLE: '上架',
    RENTING: '租借中',
    MAINTENANCE: '工單中',
    UNAVAILABLE: '下架',
    AWAITING_CAR_DATA: '等待設定車輛資料',
    SOLD_OUT: '已售出',
    STAYTIME: '停留XX小時'
};
export const CarBusinessStatusColor = {
    AVAILABLE: 'success',
    RENTING: 'warning',
    MAINTENANCE: 'info',
    UNAVAILABLE: 'none',
    ABNORMAL: 'error',
    STAYTIME: 'special'
};
export const CarTaskStatusColor = {
    NORMAL: 'success',
    ATTENTION: 'warning',
    URGENT: 'error',
    NON_TASK: 'none'
};
export const CarLogLabel = {
    door: { 0: '關門', 1: '開門' },
    light: { 0: '關閉', 1: '開啟' },
    smartbox1: { 0: '開啟', 1: '關閉' },
    lock: { 0: '上鎖', 1: '解鎖' },
    acc: { 0: '熄火', 1: '啟動' },
    handbrake: { 0: '放下', 1: '拉起' },
    pressure: { 0: '正常', 1: '異常' },
    power: { 0: '可使用', 1: '不可使用' },
    smartbox3: { 0: '燈亮', 1: '燈滅' }
};
export const CarRepairReason = [
    {
        LOST_CONNECTION: '失聯',
        INCORRECT_LOCATION: '位置不正常',
        DATA_ABNORMAL: '數據異常'
    },
    { I_BUTTON_CANNOT_DETECT: '偵測不到' },
    {
        REMOTE_LOCK: '遠端開解鎖',
        BLUETOOTH_LOCK: '藍芽開解鎖',
        REMOTE_FIND_CAR: '遠端尋車',
        REMOTE_TURN_ON_OFF: '遠端通/斷電'
    }
];

export const OrderLogOperationType = {
    ORDER_CREATE: '訂單建立',
    WAITING_FOR_PICK_UP: '訂單狀態已更新為 [ 待取車 ]',
    IN_USE: '訂單狀態已更新為 [ 使用中 ]',
    DROPPED_OFF: '訂單狀態已更新為 [ 已還車 ]',
    DROP_OFF_SPECIAL: '訂單狀態已更新為 [ 特殊還車 ]',
    DROP_OFF_SPECIAL_FINISHED: '訂單狀態已更新為 [ 特殊還車 (已結案) ]',
    CANCELLED: '訂單狀態已更新為 [ 已取消 (主動取消) ]',
    CANCELLED_TIME_OUT: '訂單狀態已更新為 [ 已取消 (逾時未取) ]',
    CANCELLED_PAYMENT_FAILED: '訂單狀態已更新為 [ 已取消 (取預售權失敗) ]',
    PAYED: '付款狀態已更新為 [ 訂單已付款 ]',
    PAY_FAIL: '付款狀態已更新為 [ 訂單付款失敗 ]',
    WAITING_FOR_PAYMENT: '付款狀態已更新為 [ 訂單待付款 ]',
    WAITING_FOR_SUPPLEMENTARY_PAYMENT: '付款狀態已更新為 [ 補繳待付款 ]',
    PRE_AUTH_SUCCESS: '預授權成功',
    PRE_AUTH_FAIL: '預授權失敗',
    PRE_AUTH_CANCEL: '預授權取消',
    REFUND_APPLY: '退款申請',
    REFUND_SUCCESS: '退款成功',
    REFUND_FAIL: '退款失敗'
};

export const TrafficTicketProcessStatusColor = {
    NOT_PROCESS: 'warning',
    WAIT_COLLECTED: 'none',
    WAIT_APPROPRIATION: 'special',
    FINISHED: 'success'
};
export const TrafficTicketPaymentStatusColor = {
    UNPAID: 'warning',
    PAID: 'info',
    PAID_WRITE_OFF: 'success',
    REMIT_WRITE_OFF: 'success'
};
export const ReceivableStatusColor = {
    PENDING_WRITE_OFF: 'warning',
    WRITTEN_OFF: 'success'
};
export const CollectionPayStatusColor = {
    UNPAID: 'warning',
    PAID: 'success',
    PAY_FAILED: 'error'
};

export const TaskType = {
    DISPATCH_TASK: '調度任務',
    SHUTTLE_TASK: '接駁任務',
    CHECKING_TASK: '檢修任務',
    REPAIR_TASK: '維修任務',
    CHARGING_TASK: '充電任務',
    OTHER_TASK: '其他任務',
    CLEAN_TASK: '清潔任務',
    FULL_CLEAN_TASK: '大清任務',
    MAINTENANCE_TASK: '保養任務',
    INSPECTION_TASK: '驗車任務'
};

export const NotificationContentType = {
    MANUEL_PERSONAL: '個人訊息',
    MANUEL_ACTIVITY: '活動通知',
    MEMBER_SUSPENSION_NOTICE: '會員停權通知',
    APP_LOGIN_NOTICE: 'APP登入通知',
    REGISTRATION_MODIFICATION_APPROVAL_SUCCESS: '註冊 / 變更審核成功',
    REGISTRATION_MODIFICATION_APPROVAL_FAILURE: '註冊 / 變更審核失敗',
    PREAUTHORIZATION_SUCCESS: '預授權通知 - 成功',
    PREAUTHORIZATION_FAILURE: '預授權通知 - 失敗',
    PREAUTHORIZATION_REFUND: '預授權通知 - 退款',
    CO_MEMBER_INVITATION: '共同承租人邀請訊息',
    CO_MEMBER_REPLY_ACCEPTED: '共同承租人接受邀請訊息',
    CO_MEMBER_REPLY_REJECTED: '共同承租人拒絕邀請訊息',
    BOOKING_SUCCESS: '訂車成功',
    CANCEL_BOOKING: '取消訂車',
    ORDER_TIMEOUT: '訂單逾時 (超時未還)',
    ORDER_TIMEOUT_APP: '訂單逾時，超過15分鐘 (超時未還)',
    SPECIAL_DROP_OFF: ' 訂單特殊還車',
    EXTEND_BOOKING: '延長用車',
    ADJUST_ORDER: '訂單調整',
    VEHICLE_CLEANLINESS_ABNORMAL: '車輛清潔狀況異常',
    VEHICLE_CLEANLINESS_NORMAL: '車輛清潔狀況轉為正常',
    VEHICLE_CONDITION_ABNORMAL_ORDER_DELAY: '車輛狀況異常/訂單工單延誤',
    RENTAL_VEHICLE_ABNORMAL: '租借中車輛異常',
    PENDING_PAYMENT_DEDUCTION_SUCCESS: '待繳費用扣款 - 成功',
    PENDING_PAYMENT_DEDUCTION_FAILURE: '待繳費用扣款 - 失敗',
    SELF_PAY_PARKING_NOTICE: '停車費自繳通知',
    SELF_PAY_FINE_NOTICE: '罰單自繳通知',
    RETURN_PAYMENT_SUCCESS: '還車請款 - 成功',
    RETURN_PAYMENT_FAILURE: '還車請款 - 失敗',
    INVOICE_WINNING_NOTICE: '發票中獎通知',
    ALLOWANCE_INVOICE_ISSUE: '折讓單開立',
    INVOICE_REPLACE_NOTICE: '換發票通知',
    REFUND_NOTICE: '退款通知',
    INVOICE_ISSUE: '發票開立',
    ORDER_COMPLETED: '訂單完成',
    SATISFACTION_SURVEY: '滿意度問卷',
    COLLECTION: '催繳通知',
    MILEAGE_REDEMPTION: '哩程兌換'
};

export const StationFormOptions = [
    { value: 'GROUP', label: '站點群組' },
    { value: 'REGION', label: '縣市行政區' }
];

export const BusinessTypes = {
    rentSameStation: 'RENT_FROM_SAME_STATION',
    rentAnyStation: 'RENT_FROM_ANY_PLACE'
};

export const BusinessTypeToZh = {
    [BusinessTypes.rentSameStation]: '同站租還',
    [BusinessTypes.rentAnyStation]: '恣意租還'
};

export const BusinessTypeToEn = {
    同站租還: BusinessTypes.rentSameStation,
    恣意租還: BusinessTypes.rentAnyStation
};

export const ParkingConfig = {
    mochipay: 'MOCHIPAY',
    parkingLot: 'PARKINGLOTAPI'
};
